import { PermissionEnum } from '@api/enum';
import { IUser } from '@api/models';
import OverflowTooltip from '@components/OverflowTooltip/OverflowTooltip';
import useAuthPermission from '@hooks/use-auth-permission';
import { Button } from '@hyperflake/react-ui-library';
import { CrossIcon, ExclamationCircleIcon } from '@icon/index';
import { Avatar } from '@library/avatar';
import { LoadingButton } from '@library/buttons';
import { Popover } from '@library/popover';
import { TRootState } from '@store/index';
import { FC, useState } from 'react';
import { useSelector } from 'react-redux';

interface DocumentUserRowProps {
    uploadedBy: IUser | string;
    user: IUser;
    onAccessRevoke: () => void;
    isLoading: boolean;
}
const DocumentUserRow = (props: DocumentUserRowProps) => {
    const { user, uploadedBy, onAccessRevoke, isLoading } = props;

    console.log('user', user);
    console.log('uploadedBy', uploadedBy);

    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);

    const { info: authUser } = useSelector((state: TRootState) => state.profile);

    const { hasPermission } = useAuthPermission();

    if (user._id === authUser._id)
        return (
            <div key={user._id} className="flex items-center gap-[10px] mt-5">
                <div>
                    <Avatar src={user.dpUrl} alt={user.name} />
                </div>

                <div className="mr-3 overflow-hidden">
                    <div className="font-medium text-sm">You</div>
                </div>
            </div>
        );

    return (
        <div key={user._id} className="flex items-center gap-[10px] mt-5">
            <div>
                <Avatar src={user.dpUrl} alt={user.name} />
            </div>

            <div className="mr-3 overflow-hidden">
                <OverflowTooltip className="font-medium text-sm">{user.name}</OverflowTooltip>
                <OverflowTooltip className="font-medium text-xs text-grayscale-400">{user.email}</OverflowTooltip>
            </div>

            {hasPermission(PermissionEnum.DOCUMENT_UPDATE) && (uploadedBy as IUser)._id !== user._id && (
                <Popover
                    open={showConfirmationDialog}
                    setOpen={setShowConfirmationDialog}
                    placement="bottom-end"
                    className="ml-auto"
                    contentClassName="bg-warning-50 fill-warning-50"
                    content={
                        <div className="flex gap-2 max-w-[328px]">
                            <div className="text-warning-500 mt-1">
                                <ExclamationCircleIcon />
                            </div>
                            <div>
                                <div className="text-sm">
                                    Are you sure you want to remove this user from the document?
                                </div>

                                <div className="flex items-center gap-3 mt-[10px]">
                                    <Button
                                        size="xs"
                                        color="secondary"
                                        onClick={() => setShowConfirmationDialog(false)}
                                    >
                                        No
                                    </Button>
                                    <LoadingButton
                                        size="xs"
                                        color="danger"
                                        onClick={onAccessRevoke}
                                        isLoading={isLoading}
                                        loadingText="Removing"
                                    >
                                        Yes
                                    </LoadingButton>
                                </div>
                            </div>
                        </div>
                    }
                >
                    <button className="text-danger-500">
                        <CrossIcon />
                    </button>
                </Popover>
            )}
        </div>
    );
};

export default DocumentUserRow;
